"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
/**
 * 获取图像内容的的外接矩形
 * @param img 图片数据
 * @param bgColor 背景颜色 可选
 */
function minExternalReact(img, bgColor) {
    var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
    if (bgColor === void 0) { bgColor = [0, 0, 0, 0]; }
    var _e = __read(utils_1.colorChannel(img), 4), R = _e[0], G = _e[1], B = _e[2], A = _e[3];
    var width = img.width, height = img.height;
    var rows = utils_1.rowIndex(width, height);
    var cols = utils_1.colIndex(width, height);
    // 寻找上边缘
    var foundFlag = false;
    var sy = 0;
    for (var r = 0; r < rows.length; r++) {
        var row = rows[r];
        try {
            for (var row_1 = __values(row), row_1_1 = row_1.next(); !row_1_1.done; row_1_1 = row_1.next()) {
                var idx = row_1_1.value;
                if (R[idx] !== bgColor[0] || G[idx] !== bgColor[1] || B[idx] !== bgColor[2] || A[idx] !== bgColor[3]) {
                    sy = r;
                    foundFlag = true;
                    break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (row_1_1 && !row_1_1.done && (_a = row_1.return)) _a.call(row_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (foundFlag) {
            break;
        }
    }
    // 寻找左边缘
    foundFlag = false;
    var sx = 0;
    for (var c = 0; c < cols.length; c++) {
        var col = cols[c];
        try {
            for (var col_1 = __values(col), col_1_1 = col_1.next(); !col_1_1.done; col_1_1 = col_1.next()) {
                var idx = col_1_1.value;
                if (R[idx] !== bgColor[0] || G[idx] !== bgColor[1] || B[idx] !== bgColor[2] || A[idx] !== bgColor[3]) {
                    sx = c;
                    foundFlag = true;
                    break;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (col_1_1 && !col_1_1.done && (_b = col_1.return)) _b.call(col_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        if (foundFlag) {
            break;
        }
    }
    // 寻找下下边缘
    foundFlag = false;
    var sh = 0;
    for (var r = rows.length - 1; r > 0; r--) {
        var row = rows[r];
        try {
            for (var row_2 = __values(row), row_2_1 = row_2.next(); !row_2_1.done; row_2_1 = row_2.next()) {
                var idx = row_2_1.value;
                if (R[idx] !== bgColor[0] || G[idx] !== bgColor[1] || B[idx] !== bgColor[2] || A[idx] !== bgColor[3]) {
                    sh = r - sy;
                    foundFlag = true;
                    break;
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (row_2_1 && !row_2_1.done && (_c = row_2.return)) _c.call(row_2);
            }
            finally { if (e_3) throw e_3.error; }
        }
        if (foundFlag) {
            break;
        }
    }
    // 寻找右边缘
    foundFlag = false;
    var sw = 0;
    for (var c = cols.length - 1; c > 0; c--) {
        var col = cols[c];
        try {
            for (var col_2 = __values(col), col_2_1 = col_2.next(); !col_2_1.done; col_2_1 = col_2.next()) {
                var idx = col_2_1.value;
                if (R[idx] !== bgColor[0] || G[idx] !== bgColor[1] || B[idx] !== bgColor[2] || A[idx] !== bgColor[3]) {
                    sw = c - sx;
                    foundFlag = true;
                    break;
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (col_2_1 && !col_2_1.done && (_d = col_2.return)) _d.call(col_2);
            }
            finally { if (e_4) throw e_4.error; }
        }
        if (foundFlag) {
            break;
        }
    }
    // 返回 左上角 宽度 高度
    return [sx, sy, sw, sh];
}
exports.minExternalReact = minExternalReact;
/**
 * 图像灰化
 * @param img 输出图片
 */
function grayscale(img) {
    var g = utils_1.addArrays.apply(void 0, __spread(utils_1.colorChannel(img).slice(0, 3))).map(function (item) { return item / 3; });
    return utils_1.mergeColorChannel([g, g, g, g.map(function () { return 225; })], img.width);
}
exports.grayscale = grayscale;
/**
 * 图像二值化
 * @param img 输入图片
 */
function binarization(img) {
    var g = utils_1.addArrays.apply(void 0, __spread(utils_1.colorChannel(img).slice(0, 3))).map(function (item) { return item / 3; })
        .reduce(function (sum, item) { return sum + item; });
    var rp = Math.floor(g / img.width / img.height); // 灰度平均值
    var r = utils_1.addArrays.apply(void 0, __spread(utils_1.colorChannel(img).slice(0, 3))).map(function (item) { return item > rp ? 225 : 0; });
    return utils_1.mergeColorChannel([r, r, r, r.map(function () { return 225; })], img.width);
}
exports.binarization = binarization;
/**
 * 输出一个图像中所有像素值不等背景像素值的索引
 * @param img 图像
 */
function getPointsFromImageData(img, bgColor) {
    if (bgColor === void 0) { bgColor = [0, 0, 0, 0]; }
    var list = utils_1.zip(utils_1.colorChannel(img));
    var result = [];
    for (var i = 0; i < list.length; i++) {
        if (list[i][0] !== bgColor[0] || list[i][1] !== bgColor[1] || list[i][2] !== bgColor[2] || list[i][3] !== bgColor[3]) {
            result.push(i);
        }
    }
    return result;
}
exports.getPointsFromImageData = getPointsFromImageData;
//# sourceMappingURL=image.js.map